import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import debounce from 'debounce'

import { ListResorts } from 'widgets/tour/list-resorts'

import { TourArrivalCity, TownTo } from 'shared/api/tours/search'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { Input } from 'shared/ui/input'

import s from './styles.module.scss'

interface TownToSelected {
  id: string
  name: string
  state?: number
  state_name?: string
  isActive?: boolean
}

interface Props {
  selected?: TownTo[]
  listResorts?: TourArrivalCity[]
  onContinue?: (id: TownTo[]) => void
}

export const ResortTypeList = ({
  selected,
  listResorts,
  onContinue,
}: Props) => {
  const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState<string>('')
  const [selectedResorts, setSelectedResorts] = useState<TownToSelected[]>(
    () => {
      if (Boolean(selected?.length)) {
        return (
          listResorts?.map((townTo) => {
            return {
              ...townTo,
              isActive: selected?.some((resort) => resort.id === townTo.id),
            }
          }) || []
        )
      }

      return listResorts || []
    },
  )

  const onClickAll = (isAllSelected?: boolean) => {
    setSelectedResorts(
      selectedResorts?.map((resort) => ({
        ...resort,
        isActive: Boolean(isAllSelected),
      })),
    )
  }

  const onClickResort = (id: string | number) => {
    const listResorts_ = [...selectedResorts]

    const index = listResorts_.findIndex(
      (resort) => String(resort.id) === String(id),
    )

    if (index < 0) return

    listResorts_[index].isActive = !Boolean(selectedResorts[index]?.isActive)

    setSelectedResorts(listResorts_)
  }

  const onClickContinue = () => {
    onContinue?.(
      filteredResorts.map((resort) => ({
        id: resort.id,
        name: resort.name,
        state: resort.state || 0,
        state_name: resort.state_name || '',
      })),
    )
  }

  const onSearchResort = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = event.target.value.toLowerCase()

    setSearchValue(searchValue)
  }

  const filteredResorts = selectedResorts.filter((resort) => resort.isActive)

  return (
    <div>
      <div className={s.searchInput}>
        <Input
          placeholder={t('nav_bar_search')}
          onChange={debounce(onSearchResort, 1000)}
          leftIcon={
            <AppIcon
              id={AllIcons.LOOP}
              className={s.icon}
              width={24}
              height={24}
            />
          }
        />
      </div>

      {/*<div className={s.headerText}>*/}
      {/*  <p className={clsx('bold-20', s.headerTitle)}>*/}
      {/*    {t('tours_block.resort')}*/}
      {/*  </p>*/}
      {/*</div>*/}

      <ListResorts
        searchResort={searchValue}
        listTours={selectedResorts}
        onClick={onClickResort}
        onAllResorts={onClickAll}
      />

      <ButtonContinue
        onClick={onClickContinue}
        disabled={!Boolean(filteredResorts?.length)}
      >
        <span className={clsx('bold-16', s.continue)}>
          {t('select_without_date')}
        </span>
      </ButtonContinue>
    </div>
  )
}
